module.exports = __webpack_public_path__ + "img/rooster.126d3ccf.png";